module.exports = __webpack_public_path__ + "static/img/10.d1d8d06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/10.png
// module id = sS2R
// module chunks = 0